import { createFileRoute } from '@tanstack/react-router';
import { apiFinanceiroContaGetQueryOptions } from '@/features/financeiro-conta/api/apiFinanceiroContaGet';
import { queryClient } from '@/queryClient';
import { validateRoute } from '@/router/util';

export const Route = createFileRoute('/a/pagfor')({
    beforeLoad: async () => {
        const data = await queryClient.query(apiFinanceiroContaGetQueryOptions());

        const isPagFor =
            Array.isArray(data.registros) &&
            data.registros.some((item) => item?.banco?.fcb_financeiro_banco_pagfor === 1);

        validateRoute({
            condition: isPagFor,
            fintech: true,
        });
    },
});
